import React, { useState } from "react";
import { Alert, Box, Link } from "@mui/material";
import DatePicker from "../DatePicker/DatePicker";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import moment from "moment";
interface Props {
  attrName: any;
  title: string;
  value: any;
  value_update: Function;
  error_message: string;
  warn_status: boolean;
  class_name: string;
  params?: any;
  id?: string;
}

const DatePickerDisable: React.FC<Props> = ({
  title,
  value,
  value_update,
  attrName,
  error_message,
  warn_status,
  class_name,
  params,
  id,
}) => {
  const [disbaleToggle, setDisableToggle] = useState<boolean>(false);

  const updateMasterState = (attrName: any, value: any) => {
    console.log(";;;;;...", value);
    value_update(attrName, value);
  };
  const individual_edit = () => {
    // Patch(`${URL_CONSTANTS.edit_contact}${id}`, params).then((data: any) => {
    //   let status = data[0];
    //   let response = data[1];
    //   console.log(data);
    //   if (status === "success") {
    //     alert("Data update successfully");
    //   }
    //   if (status.response.data.status === "failed") {
    //     console.log("eeeee---", status.response.data.errors[0].message);
    //     let param = status.response.data.errors[0].param;
    //     let error = status.response.data.errors[0].message;
    //     alert(param + " " + " " + error);
    //   }
    // });
  };
  return (
    <Box className="individualEdit">
      {disbaleToggle === false ? (
        <div className="staticField">
          <label>{title}</label>
          <p>{moment(value).format("DD/MM/YYYY")}</p>
        </div>
      ) : (
        <DatePicker
          class_name="inputField"
          title="Date of Birth"
          value={value}
          attrName={attrName}
          value_update={updateMasterState}
          error_message="Enter valid Date of Birth"
          warn_status={false}
        />
      )}
      <Link
        className={disbaleToggle === true ? "editUpdate visible" : "editUpdate"}
        onClick={() => {
          setDisableToggle(!disbaleToggle);
          if (disbaleToggle === true) {
            individual_edit();
          }
        }}
      >
        {disbaleToggle === false ? <EditIcon /> : <CheckIcon />}
      </Link>
    </Box>
  );
};

export default DatePickerDisable;
